import { matchRequestCodeV2, matchVersionV2, ScheduleVersionRequestRef } from '@csp/csp-common-scheduling';
import { VisitsScheduleContentModel } from '@csp/csp-web-content-definitions';
import { ScheduleVisitTexts } from './ScheduleVisitTexts';

export type ScheduleVisitsContent = {
  cmsTexts: VisitsScheduleContentModel[];
  getScheduleVisitTexts(requestRef: ScheduleVersionRequestRef): ScheduleVisitTexts;
};

const getScheduleVisitTexts = (
  texts: VisitsScheduleContentModel[],
  { scheduleCode, versionCode, requestCode }: ScheduleVersionRequestRef,
): ScheduleVisitTexts => {
  let correctSchedule = texts.find(
    schedule =>
      schedule.schedule_code === scheduleCode && matchVersionV2<VisitsScheduleContentModel>(versionCode, schedule),
  );

  // If we can't match on version try to match only on schedule code when the schedule is missing version
  if (!correctSchedule) {
    correctSchedule = texts.find(schedule => schedule.schedule_code === scheduleCode && !schedule.version);
  }

  const correctRequest = correctSchedule?.visits?.find(
    visit =>
      matchRequestCodeV2<{ request_code: string }>(requestCode, { request_code: visit.visit_id }) && visit.visit?.[0],
  );
  const correctVisit = correctRequest?.visit?.[0];

  return {
    title: correctVisit?.visit_title ?? requestCode,
    hcpDescriptionMd: correctVisit?.visit_purpose_md,
    patientDescriptionMd: correctVisit?.patient_description_md,
    preActivitiesMd: correctVisit?.patient_pre_activities_description_md,
    visitKind: correctVisit?.visit_type,
    visitConfirmationLearnMore: correctVisit?.visit_confirmation_learn_more,
    bioSampleKitDescriptions: correctVisit?.sample_kit,
    bioSampleAnalyteTypes: correctVisit?.sample_analyte_type || [],
    bioSampleSampleTypes: correctVisit?.sample_type || [],
    bioSampleProcessedSampleTypes: correctVisit?.processed_sample_type || [],
  };
};

const fromCmsScheduleVisits = (unifyScheduleVisits: VisitsScheduleContentModel[]): ScheduleVisitsContent => ({
  cmsTexts: unifyScheduleVisits,
  getScheduleVisitTexts: (requestRef: ScheduleVersionRequestRef) =>
    getScheduleVisitTexts(unifyScheduleVisits, requestRef),
});

export const ScheduleVisitsContent = {
  fromCmsScheduleVisits,
};
